import { memo, ReactNode } from "react";
import { ApolloProvider } from "@apollo/client";
import { useCreateClient } from "api/apollo";

export type ApiProviderProps = {
  children?: ReactNode | ReactNode[]
}

export const ApiProvider = memo<ApiProviderProps>(({ children }) => {
  const client = useCreateClient();

  return (
    <ApolloProvider client={client as any}>
      {children}
    </ApolloProvider>
  );
});

export default ApiProvider;
